export enum GroupRelation {
  Drafting = 'Drafting',
  Owner = 'Owner',
  Member = 'Member',
  Moderator = 'Moderator',
  Administrator = 'Administrator',
  Requested = 'Requested',
  Invited = 'Invited',
}
